/**
 * Landing Voice AI client settings (@pleased-npm/voice-ai-client).
 */
export const VOICE_AI_CONFIG = {
  baseUrl: 'https://voice-ai-uat.pleased2.com',
};
